import { googleAnalyticsSubmitForm } from '../../../js/datalayer'
import * as Pristine from '../../../js/vendor/Pristine'

const FORM_SELECTORS = {
    VALIDATION_CONTAINER: 'form__group',
    VALIDATION_ERROR: 'error',
    SUMMARY_CONTAINER: ':scope .form__validation-summary',
    ACTIVE_ERROR_LISTS: ':scope .form__group.error',
    ACTIVE_ERROR_LIST_ITEM: '.form__error-message',
    INPUT_NON_HIDDEN: "input:not([type='hidden'])",
    ERROR_MESSAGE_REQUIRED: '.form__error-message.required',
    ERROR_MESSAGE_VALIDATION: '.form__error-message.validation',
    SUBMIT_BUTTON: '.button-form-submit',
  }

const NewsletterSignup = {
    init: function (element, validationEnabled = true) {
      element.formValidator = this;
      this.form = element
      this.validationEnabled = validationEnabled
      this.pristineFormInstance = new Pristine(element, {
        classTo: FORM_SELECTORS.VALIDATION_CONTAINER,
        errorClass: FORM_SELECTORS.VALIDATION_ERROR,
      });
      this.submitBtn = this.form.querySelector(FORM_SELECTORS.SUBMIT_BUTTON);
      if (this.submitBtn && this.submitBtn.addEventListener) {
        this.submitBtn.addEventListener('click', this.onClickSubmitBtn.bind(this));
      } else{
        this.form.addEventListener('submit', this.onClickSubmitBtn.bind(this))
      }

      if (!validationEnabled) {
        return
      }
    },

    onClickSubmitBtn: function (evt) {
      if (!this.validationEnabled) {
        evt.preventDefault();
        return;
      }

      const validateResult = this.pristineFormInstance.validate();
      if (!validateResult) {
        return;
      } else {
        const { newsletterSignup } = this.getFormContainers()
        let action = this.form.action;

        let data = new FormData(this.form)
        googleAnalyticsSubmitForm(this.form);
        alert("Thanks for Joining! You're in good company!")

        fetch(action, {
          method: 'POST',
          body: data,
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if (data.success) {
              this.form.style.display = 'none';
            } else {
              if (newsletterSignup) {
                let message = data.message
                newsletterSignup.value = message
              }
            }
            this.form.submit();
          })
          .catch((err) => {
            if (newsletterSignup) {
                newsletterSignup.value = err
              }
          }).finally(() => {
            const input = this.form.querySelector('.text-field');
            if (input) {
                input.value = '';
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
          });
      }
    },

    getFormContainers: function () {
      return {
          form: document.querySelector('form.form'),
          newsletterSignup: document.querySelector('#email-signup__input')
      }
    },

    resetValidationErrors: function () {
      if (this.pristineFormInstance) {
          this.pristineFormInstance.reset();
      }
      const { success, error, errorDetail, form } = this.getFormContainers();
      if (success) {
          success.style.display = 'none';
      }
      if (error) {
          error.style.display = 'none';
      }
      if (errorDetail) {
          errorDetail.style.display = 'none';
      }
      if (form) {
          form.style.display = 'initial';
      }
    }

  }

  export default NewsletterSignup
